import { getReturnReasons } from "../lib/reasons.lib";
import type { ReturnReason } from "../types";
import { usePublicShop } from "../queries/use-public-shop";
import { usePublicOrder } from "../queries/use-public-order";
import { useWidgetParams } from "./use-widget-params";
import { useIsMerchant } from "./use-is-merchant";
import { useTranslation } from "react-i18next";

export function useReturnReasons(shopId: string): ReturnReason[] {
  const { data: shop } = usePublicShop(shopId);
  const { orderId } = useWidgetParams();
  // The retractation reason is only offered during the 14 days after the sale;
  // eligibility is computed server-side and exposed on the order's `opt`.
  const { data: order } = usePublicOrder(orderId);
  const { i18n } = useTranslation();
  // Reasons marked "reserved for logged user" (e.g. "Marketplace, réservé au
  // service client") are meant for merchant/staff use, not storefront customers.
  const isMerchant = useIsMerchant();

  return getReturnReasons(shop, i18n.language, {
    isMerchant,
    retractationEligible: order?.opt?.retractationEligible,
  });
}
